import Vue from 'vue'

const EventBus = new Vue();

EventBus.trigger = function(fields, name) {
    if(!fields) return;

    let results = [];

    if(Array.isArray(fields)) {
        fields.forEach(item=> {
            if(!item.trigger) return;
            results = results.concat(setTrigger(item.trigger,name));
        })
    }
    else if(fields.trigger){
        results = results.concat(setTrigger(fields.trigger, name));
    }

    return Array.from(new Set(results));
}

EventBus.formItemTrigger = function(trigger, value) {
    if(!this 
        || !this.FormItem 
        || !this.FormItem.triggers 
        || !this.FormItem.triggers.length
    ) {
        return;
    }

    this.FormItem.triggers.includes(trigger) 
        && this.FormItem.onTrigger(trigger, value)

}

const setTrigger = function(trigger) {
    let results = [];

    if(Array.isArray(trigger)) {
        results = results.concat(trigger)
    }
    else {
        results.push(trigger)
    }
    return results;
};

export default EventBus